import { render, staticRenderFns } from "./Pile.vue?vue&type=template&id=71bc0ea6&scoped=true&"
import script from "./Pile.vue?vue&type=script&lang=js&"
export * from "./Pile.vue?vue&type=script&lang=js&"
import style0 from "./Pile.vue?vue&type=style&index=0&id=71bc0ea6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bc0ea6",
  null
  
)

export default component.exports